module.exports = __webpack_public_path__ + "img/Trasnparent.0fbf67bd.png";